// ProfileCard.js
import WebSite from "./WebSite";
import App from "./App";
import Condesa from "./Condesa";
import PromoCode from "./PromoCode";
import GoogleHotels from "./GoogleHotels";
import Tripadvisor from "./Tripadvisor";
import HolidayCheck from "./HolidayCheck";
import Share from "./Share";
import VCard from "./vCard";
import "./ProfileCard.css";

const ProfileCard = () => (
  <div className="container">
    <div className="card-container">
      {/* PARTE 1: Imagen y descripción */}
      <div className="card-header">
        <div className="image">
          <img
            src="/images/profile-image.png"
            alt="Imagen Lidia RRPP Hotel Condesa"
          />
        </div>
        <div className="descripcion">
          <h1>Lidia</h1>
          <h2>Guest Experience Team</h2>
          <Condesa />
          <p className="promo-code-title">Your promo code for a discount:</p>
          <p className="promo-code">
            <PromoCode />
          </p>
          <p className="email-contenedor">
            <span className="hover-text">
              <a
                href="mailto:rrpp@hotelcondesa.com"
                className="phone-link"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <i
                  className="bi bi-envelope"
                  style={{ marginRight: "8px" }}
                ></i>
                rrpp@hotelcondesa.com
              </a>
              <span className="tooltip-text fade">Enviar correo</span>
            </span>
          </p>
          <GoogleHotels />
          <Tripadvisor />
          <HolidayCheck />
        </div>
      </div>
      {/* PARTE 2: Imagen QR (que crece) */}
      <div className="qr-flex-grow">
        <div className="image-qr">
          <img
            src="/images/qr-lidia.jpg"
            alt="Imagen QR Lidia"
          />
        </div>
      </div>
      {/* PARTE 3: Botones e iconos (footer incluido) */}
      <div className="card-footer">
        <div className="buttons">
          <WebSite />
          <App />
          <VCard />
          <Share />
        </div>
        <footer className="footer">
          <p
            style={{
              fontSize: "0.75rem",
              color: "#999",
              textAlign: "center",
              marginTop: "0rem",
            }}
          >
            Powered by <strong>Digital Card</strong> ·{" "}
            <a
              href="https://digitalcard.store"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#999" }}
            >
              digitalcard.store
            </a>
          </p>
        </footer>
      </div>
    </div>
  </div>
);

export default ProfileCard;
